import React, { FC } from 'react';
import { ReactComponent as Check } from '../../../assets/Common/CheckIcon.svg';

export const CheckIcon: FC = () => <Check />;
